import { XIcon } from "@heroicons/react/outline";
import {} from "@heroicons/react/solid";
import { React, useState, useRef } from "react";

const DeptModal = ({ title, url, show, onCloseCallback }) => {
  const [toggle, setToggle] = useState(true);
  const [toggle2, setToggle2] = useState(true);
  const [toggle3, setToggle3] = useState(true);
  const [enter, setEnter] = useState(false);
  const [addDept, setAddDept] = useState({
    name: "",
    abbr: "",
  });
  const handleAddDept = (event) => {
    setAddDept({
      ...addDept,
      [event.target.name]: event.target.value,
    });
  };

  const input = {
    name: useRef(null),
    abbr: useRef(null),
  };

  const toggleClass = " transform translate-x-5";

  if (!show) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden flex justify-center items-center z-50 md:inset-0 h-modal md:h-full bg-[rgba(0,0,0,0.6)]"
    >
      <div className="relative p-4 w-full max-w-xl h-full md:h-auto">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          {/* <!-- Modal header --> */}
          <div className="flex flex-row place-items-center justify-end">
            <h1 className="px-4 py-3 text-lg font-normal text-gray-700">
              {title}
            </h1>
            <button
              onClick={() => onCloseCallback()}
              type="button"
              className="rounded-lg text-sm ml-auto px-4 py-3 inline-flex items-center"
              data-modal-toggle="popup-modal"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="w-full h-0.5 bg-gray-200 mb-1"></div>
          {/* <!-- Modal body --> */}
          <div className="py-3 text-center h-72">
            <form className="mb-4 w-full flex flex-row flex-wrap justify-center">
              <input
                className="bg-[#E4E6FF] border-2 rounded-lg w-1/2 mr-2 py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1"
                id="name"
                type="text"
                name="name"
                value={addDept.name}
                onChange={handleAddDept}
                autoComplete="off"
                ref={input["name"]}
                placeholder="Department Name"
              />
              <input
                className="bg-[#E4E6FF] border-2 rounded-lg w-1/4 mr-2 py-1 px-4 text-gray-700 leading-none focus:bg-white border-transparent focus:border-transparent focus:ring-1"
                id="abbr"
                type="text"
                name="abbr"
                value={addDept.abbr}
                onChange={handleAddDept}
                autoComplete="off"
                ref={input["abbr"]}
                placeholder="Abbreviation"
              />
              <div
                className="bg-[#6767ce] hover:bg-[#4242A8] text-white py-1 rounded-lg w-1/6 hover:cursor-pointer"
                onClick={() => {
                  if (
                    addDept.name === "Computer Science" &&
                    addDept.abbr === "CS"
                  ) {
                    setEnter(true);
                    setAddDept({
                      name: "",
                      abbr: "",
                    });
                  }
                }}
              >
                ADD
              </div>
            </form>
            {/* table */}
            <div class="container flex justify-center mx-auto scroll-auto">
              <div class="flex flex-col">
                <div class="w-full">
                  <div class="border-b border-gray-200 shadow">
                    <table>
                      <thead class="flex bg-gray-200 w-full">
                        <tr className="whitespace-nowrap">
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-16">Abbr</div>
                          </th>
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-36">Name</div>
                          </th>
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-10">Active</div>
                          </th>
                          <th class="px-6 py-4 text-sm text-gray-500">
                            <div class="text-sm w-16">Delete</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        class="flex flex-col overflow-y-scroll"
                        style={{ height: 22 + "vh" }}
                      >
                        {enter && (
                          <tr class="whitespace-nowrap">
                            <td class="px-6 py-4">
                              <div class="text-sm text-gray-900 w-16">CS</div>
                            </td>
                            <td class="px-6 py-4">
                              <div class="group text-sm text-gray-500 w-36 truncate">
                                Computer Science
                                <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                  Computer Science
                                </span>
                              </div>
                            </td>
                            <td class="px-6 py-4 text-sm text-gray-500">
                              <div className="flex flex-col justify-center items-center w-10">
                                {/*   Switch Container */}
                                <div
                                  className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                    toggle ? "bg-green-200" : "bg-red-200"
                                  }`}
                                  onClick={() => {
                                    setToggle(!toggle);
                                  }}
                                >
                                  {/* Switch */}
                                  <div
                                    className={
                                      "bg-[#696969] h-3 w-3 rounded-full shadow-md transform duration-300 ease-in-out" +
                                      (toggle ? toggleClass : null)
                                    }
                                  ></div>
                                </div>
                              </div>
                            </td>
                            <td class="px-6 py-4">
                              <button class="p-1 text-sm text-white bg-red-400 rounded w-16">
                                Delete
                              </button>
                            </td>
                          </tr>
                        )}
                        <tr class="whitespace-nowrap">
                          <td class="px-6 py-4">
                            <div class="text-sm text-gray-900 w-16">AIDS</div>
                          </td>
                          <td class="px-6 py-4">
                            <div class="group text-sm text-gray-500 w-36 truncate">
                              Artificial Intelligence and Data Science
                              <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                Artificial Intelligence and Data Science
                              </span>
                            </div>
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            <div
                              className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                toggle2 ? "bg-green-200" : "bg-red-200"
                              }`}
                              onClick={() => {
                                setToggle2(!toggle2);
                              }}
                            >
                              {/* Switch */}
                              <div
                                className={
                                  "bg-[#696969] h-3 w-3 rounded-full shadow-md transform duration-300 ease-in-out" +
                                  (toggle2 ? toggleClass : null)
                                }
                              ></div>
                            </div>
                          </td>
                          <td class="px-6 py-4">
                            <button class="p-1 text-sm text-white bg-red-400 rounded w-16">
                              Delete
                            </button>
                          </td>
                        </tr>
                        <tr class="whitespace-nowrap">
                          <td class="px-6 py-4">
                            <div class="text-sm text-gray-900 w-16 ">IT</div>
                          </td>
                          <td class="px-6 py-4">
                            <div class="group text-sm text-gray-500 w-36 truncate">
                              Information Technology
                              <span class="absolute z-50 hidden px-4 py-1 -mt-12 text-center bg-gray-500 rounded tooltip-text text-gray-100 group-hover:block">
                                Information Technology
                              </span>
                            </div>
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            <div
                              className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                toggle3 ? "bg-green-200" : "bg-red-200"
                              }`}
                              onClick={() => {
                                setToggle3(!toggle3);
                              }}
                            >
                              {/* Switch */}
                              <div
                                className={
                                  "bg-[#696969] h-3 w-3 rounded-full shadow-md transform duration-300 ease-in-out" +
                                  (toggle3 ? toggleClass : null)
                                }
                              ></div>
                            </div>
                          </td>
                          <td class="px-6 py-4">
                            <button class="p-1 text-sm text-white bg-red-400 rounded w-16">
                              Delete
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeptModal;
